import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const GoalDescriptorsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
`;

export const GoalDescriptor = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['10m']}
    display: flex;
    background-color: ${({ theme }) => theme.Utility.critical};
    color: ${({ theme }) => theme.Utility.contrast};
    padding: 3px 5px;
    align-items: center;
    text-align: center;
    border-radius: 4px;
    height: 16px;
`;
